import React from "react";

export default function GameOverScreen({ gameOverType }) {
  const messages = {
    goal: { text: "GOAL!", color: "text-yellow-400" },
    battery: { text: "BATTERY EMPTY", color: "text-red-500" },
  };

  const message = messages[gameOverType];

  return (
    <div className="w-full h-screen bg-gray-800 flex items-center justify-center">
      <h1 className={`text-7xl font-bold ${message.color}`}>{message.text}</h1>
    </div>
  );
}
